'use client'
import { useRef } from 'react'

import FormRenderer from '@/components/common/Forms/FormRenderer'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { handleSubmitError } from '@/lib/form-submit-error-handler'

import type { FormType } from '@/types/contentful/formType'

export const ContactForm = ({ form }: { form: FormType }) => {
  const formRef = useRef<HTMLDivElement>(null)
  const isDesktop = useMediaQuery('(min-width: 768px)') ?? false

  return (
    <div ref={formRef} className="flex w-full flex-col gap-6 rounded-xl bg-white p-6 shadow-sm md:flex-row md:gap-[92px]">
      <FormRenderer src={form?.fields?.formSchemaUrl} onError={() => handleSubmitError({ formRef, isDesktop })} />
    </div>
  )
}
